import { create } from 'zustand';
import Cookies from 'js-cookie';

export interface PromptState {
  showingAgeVerification: boolean;
  ageVerificationCompleted: boolean;
  showingNameRequestForm: boolean;
}

export type PromptAction = {
  setShowingAgeVerification: (arg0: boolean) => void;
  setAgeVerificationCompleted: (arg0: boolean) => void;
  setShowingNameRequestForm: (arg0: boolean) => void;
};

const initialState: PromptState = {
  showingAgeVerification: false,
  ageVerificationCompleted: Cookies.get('ageConfirmed') === 'true',
  showingNameRequestForm: false
};

const useRequiredPromptStore = create<PromptState & PromptAction>((set) => ({
  ...initialState,
  setShowingAgeVerification: (val: boolean) => set(() => ({ showingAgeVerification: val })),
  setAgeVerificationCompleted: (val: boolean) => set(() => ({ ageVerificationCompleted: val })),
  setShowingNameRequestForm: (val: boolean) => set(() => ({ showingNameRequestForm: val }))
}));

export { useRequiredPromptStore };
